module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "TITLE"
  }, [_vm._v("The Election of Grace")]), _vm._v(" "), _c('p', {
    staticClass: "SUBTITLE"
  }, [_vm._v("A Riddle without a Resolution?")]), _vm._v(" "), _c('p', {
    staticClass: "AUTHOR"
  }, [_vm._v("Stephen N. Williams")]), _vm._v(" "), _c('p', {
    staticClass: "COMPANY"
  }, [_vm._v("William B. Eerdmans Publishing Company"), _c('br'), _vm._v("Grand Rapids, Michigan / Cambridge, U.K.")]), _vm._v(" "), _c('p', {
    staticClass: "COPYRIGHT"
  }, [_vm._v("© 2015 Stephen N. Williams"), _c('br'), _vm._v("All rights reserved"), _c('br'), _c('br'), _vm._v("Published 2015 by"), _c('br'), _vm._v("Wm. B. Eerdmans Publishing Co."), _c('br'), _vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /"), _c('br'), _vm._v("P.O. Box 163, Cambridge CB3 9PU U.K."), _c('br'), _c('br'), _vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "LIBRARY"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Williams, Stephen N. (Stephen Nantlais)"), _c('br'), _vm._v("The election of grace: a riddle without a resolution? / Stephen N. Williams."), _c('br'), _vm._v("pages   cm"), _c('br'), _vm._v("Includes index."), _c('br'), _vm._v("ISBN 978-0-8028-3780-6 (pbk.: alk. paper)"), _c('br'), _vm._v("eISBN 978-1-4674-4327-2 (ePub)"), _c('br'), _vm._v("eISBN 978-1-4674-4287-9 (Kindle)"), _c('br'), _vm._v("1. Election (Theology) I. Title."), _c('br'), _c('br'), _vm._v("BT810.3.W55 2015"), _c('br'), _vm._v("234 — dc23"), _c('br'), _vm._v("                2014041181")]), _vm._v(" "), _c('p', {
    staticClass: "URL"
  }, [_c('a', {
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a32859b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Williams_The_Election_of_Grace_text_CC-2.vue
// module id = 63
// module chunks = 0